<template>

    <div class="donation-card-wrapper">
        <div class="donation-card bg-day-opportunities">
            <div class="donation-card-image">
                <div class="sizing-container">
                    <img :src="sizingImg" alt="" class="sizing-image d-flex">
                    <img :src="image" alt="Donation Image" class="sizing-img object-fit-cover">
                </div>
            </div>
            <div class="py-3 px-4 sm-p-2 bg-day-opportunities">
                <label for="custom_value" class="c-white fw-bold fs-14 lh-15">Other amount £:</label>
                <div class="input-text-button mt-4px">
                    <form @submit.prevent="confirm">
                        <input type="number" id="custom_value" name="custom_value" class="input-text-button__text" v-model="value" required>
                        <button class="btn --small" @click="confirm">Donate</button>
                    </form>
                </div>
                <div
                    v-if="description"
                    class="text-center c-white fs-16 fw-light mt-3 sm-mt-2 lh-15 px-1 sm-px-0">{{ description }}</div>
            </div>
        </div>
    </div>

</template>

<script>

    export default {
        name: 'DonationOption',
        props: {
            data: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                value: 0
            }
        },

        computed: {
            amount() {
                return this.data.default_value;
            },
            description() {
                return this.data.description;
            },
            image() {
                return this.data.image;
            },
            base() {
                return window.imgUrl;
            },
            sizingImg() {
                return this.base + '/svg/16-9-sizing.svg';
            },
        },

        watch: {
            amount: {
                immediate: true,
                handler(val) {
                    this.value = val;
                }
            }
        },

        methods: {
            confirm() {
                if (!this.value) return;
                this.$emit('selected', {
                    amount: this.value,
                    description: this.description
                });
            }
        }
    }

</script>
